import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './_helpers';
import {JustOnWebLoginComponent} from '@app/just-on-web-login/just-on-web-login.component';
import {JustOnWebResolver} from '@app/just-on-web-login/just-on-web.resolver';

const routes: Routes = [
  {
    path: 'justOnWeb/:id',
    resolve: {login: JustOnWebResolver},
    component: JustOnWebLoginComponent
  },
  { path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },
  { path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule)
  },
  {path: '**', redirectTo: ''},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
